<template>
  <div>
    <p class="text-h4 text-sm-h4 sub-title">Identification</p>
    <!-- Prenom -->
    <v-text-field v-model="renseignementsGeneraux.firstName"
                  :rules="rules.firstName"
                  label="Prénom"
                  :disabled="disableNomPrenom"
                  required
                  class="cssRequired"></v-text-field>
    <!-- Nom -->
    <v-text-field v-model="renseignementsGeneraux.lastName"
                  :rules="rules.lastName"
                  label="Nom"
                  :disabled="disableNomPrenom"
                  required
                  class="cssRequired"></v-text-field>
    <!-- Date de naissance readonly si inscription-->
    <v-menu ref="menu"
            v-model="dateMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
            :rules="rules.birthday"
            autocomplete="off"
            required>
      <template v-slot:activator="{ on, attrs }">
        <v-sheet max-width="200">
          <v-text-field v-model="renseignementsGeneraux.dateDeNaissance"
                        label="Date de naissance"
                        append-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                        :rules="rules.birthday"
                        required
                        class="cssRequired"
                        v-mask="'####-##-##'"
                        hint="Format YYYY-MM-DD"
                        readonly
                        :disabled="disableDateNaissance"/>
        </v-sheet>
      </template>
      <v-date-picker ref="picker"
                     v-model="renseignementsGeneraux.dateDeNaissance"
                     :rules="rules.birthday"
                     required
                     class="cssRequired"
                     @change="save"
                     :max="new Date().toISOString().substr(0, 10)"
										 :active-picker.sync="activePicker"/>
    </v-menu> 
  </div>
</template>

<script>
  import { mapMutations } from "vuex";
  import CanadaPost from '../common/canadaPost/CanadaPost';

  export default {
    components: {
      CanadaPost: CanadaPost
    },
    props: {
      renseignementsGeneraux: Object,
      rules: Object,
      isDemandeAdmissionPublique: {
        type: Boolean,
        default: false
      },
      disableDateNaissance: {
        type: Boolean,
        default: false
      },
      disableNomPrenom: {
        type: Boolean,
        default: false
      },
    },
    data: function () {
      return {
        dateMenu: false,
        activePicker: null,
      }
    },
    created () {
    },
    computed: {
      cellulaireLabel () {
        return this.isDemandeAdmissionPublique == true ? "Téléphone" : "Cellulaire";
      },
    },
    watch: {
      dateMenu (val) {
        val && setTimeout(() => (this.activePicker = 'YEAR'))
      },
    },
    methods: {
      ...mapMutations({
        setRenseignementsGeneraux: "RenseignementsGeneraux/setRenseignementsGeneraux",
      }),
      itemText: (item) => item.lang00,
      itemValue: (item) => item.id,
      save (date) {
        this.$refs.menu.save(date)
      },
      validate () {
        this.setRenseignementsGeneraux(this.renseignementsGeneraux);
        this.$emit("validate-form")
      },
      modelChange () {
        this.$nextTick(() => {
          this.model = null
        })
      },
    }
  }
</script>

<style>
</style>